export const asianCodes = [
  'AF',
  'AM',
  'AZ',
  'BH',
  'BD',
  'BT',
  'IO',
  'BN',
  'KH',
  'CN',
  'CC',
  'GE',
  'HK',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IL',
  'JP',
  'JO',
  'KZ',
  'KW',
  'KG',
  'LA',
  'LB',
  'MO',
  'MY',
  'MV',
  'MN',
  'MM',
  'NP',
  'KP',
  'OM',
  'PK',
  'PS',
  'PH',
  'QA',
  'SA',
  'SG',
  'KR',
  'LK',
  'SY',
  'TW',
  'TJ',
  'TH',
  'TR',
  'TM',
  'AE',
  'UZ',
  'VN',
  'YE',
]

export const asianNationalities = [
  'Afghan',
  'Armenian',
  'Azerbaijani, Azeri',
  'Bahraini',
  'Bangladeshi',
  'Bhutanese',
  'BIOT',
  'Bruneian',
  'Cambodian',
  'Chinese',
  'Cocos Island',
  'Georgian',
  'Hong Kong, Hong Kongese',
  'Indian',
  'Indonesian',
  'Iranian, Persian',
  'Iraqi',
  'Israeli',
  'Japanese',
  'Jordanian',
  'Kazakhstani, Kazakh',
  'North Korean',
  'South Korean',
  'Kuwaiti',
  'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
  'Lao, Laotian',
  'Lebanese',
  'Macanese, Chinese',
  'Malaysian',
  'Maldivian',
  'Mongolian',
  'Burmese',
  'Nepali, Nepalese',
  'Omani',
  'Pakistani',
  'Palestinian',
  'Philippine, Filipino',
  'Qatari',
  'Saudi, Saudi Arabian',
  'Singaporean',
  'Sri Lankan',
  'Syrian',
  'Chinese, Taiwanese',
  'Tajikistani',
  'Thai',
  'Turkish',
  'Turkmen',
  'Emirati, Emirian, Emiri',
  'Uzbekistani, Uzbek',
  'Vietnamese',
  'Yemeni',
]
